export const selectGroupSettingsName = (state) => state.settings.self.groupSettingsName
